"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Linkify = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var linkify_it_1 = __importDefault(require("linkify-it"));
var linkify = new linkify_it_1.default({ fuzzyLink: false, fuzzyIP: false, fuzzyEmail: false });
function parseString(str) {
    var matches = linkify.match(str);
    if (!matches)
        return str;
    var elements = [];
    var lastIndex = 0;
    for (var i = 0; i < matches.length; ++i) {
        var match = matches[i];
        if (match.index > lastIndex) {
            elements.push(str.substring(lastIndex, match.index));
        }
        var decoratedComponent = ((0, jsx_runtime_1.jsx)("a", { href: match.url, target: "_blank", rel: "noopener noreferrer", children: match.text }, i));
        elements.push(decoratedComponent);
        lastIndex = match.lastIndex;
    }
    if (str.length > lastIndex)
        elements.push(str.substring(lastIndex));
    return elements;
}
exports.Linkify = React.memo(function (_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: typeof children === "string" ? parseString(children) : children }));
});
